{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Дивитись усі варіанти",
  "Spoiler_Reveal_Tooltip": "Натисніть, щоб розкрити",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Твітнути",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Елемент згорнуто",
  "Spoiler_Reveal_Video_CTA": "Розкрити відео",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Розгорнути зображення",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Дивитись усі результати",
  "Spoiler_Reveal_Image_Placeholder": "На цьому зображенні є спойлер",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Слайдер гучності",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Ви можете проголосувати більше ніж за одну відповідь.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Показати більше елементів керування аудіо",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Закрити",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Завантаження {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Аватар користувача",
  "Preview_ReadMore_Label": "Читати далі",
  "Spoiler_Insert_Tooltip": "Спойлер",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Гучність",
  "Spoiler_Reveal_Gallery_Placeholder": "У цій галереї є спойлер",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Записатися",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Скасувати приглушення",
  "Spoiler_Reveal_Gallery_CTA": "Розкрити галерею",
  "Poll_Viewer_ShowLess_CTA": "Показати менше",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Приглушити",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "Анонімних гостей: +{{anonNumber}}",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Стежити",
  "VerticalEmbed_Products_Button": "Купити зараз",
  "Poll_Viewer_Toast_Error_ServerDown": "Немає зв'язку з сервером Повторіть спробу пізніше.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} людина проголосувала за цю відповідь",
  "Poll_Viewer_VoteCount": "Голосів: {{number}}",
  "VerticalEmbed_Events_Button": "Зареєструватися",
  "Spoiler_Reveal_Image_CTA": "Розкрити зображення",
  "Poll_Viewer_Toast_Error_Connection": "Відсутній інтернет. Перевірте з'єднання.",
  "Poll_Viewer_Visibility_Owner_Footer": "Результати бачите лише ви.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Людей, які проголосували за цю відповідь: {{count}}",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Елемент розгорнуто",
  "Audio_Plugin_Cover_Alt": "Обкладинка аудіо",
  "Spoiler_Reveal_Video_Placeholder": "У цьому відео є спойлер",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Переглянути весь пост",
  "UploadFile_Viewer_Download": "Завантажити {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} год.",
  "VerticalEmbed_Units_Minute": "{{minutes}} хв.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
